import React, { Component } from 'react';
import { Page } from 'components/page-container';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { setSort } from 'actions/filters';
import { ISortModel } from 'reducers/filters/models';
import { setSortForTable } from 'utilities/tables';
import { INickname } from 'reducers/nickname';
import InPageDialog from '../../../components/page-dialog';
import { RouteComponentProps, withRouter } from 'react-router';

import {
	clearFilters,
	resetSort,
	setFilter,
	applyFiltersAction
} from 'actions/filters';
import { fetchBlobFileUpload, fetchOutputFile } from 'actions/historyLog';
import { ISort } from 'views/job-costing/search/models';
import { fetchUploadedChargeLogs } from 'actions/ets';
import { ExceptionManagement } from 'components/exception-management/ExceptionManagement';
import { colsUploadCharge } from 'components/exception-management/constants';

interface IMapState {
	bulkUploadLogsExport: any;
	nickname: INickname;
	blob: any,
	outputBlob: any,
	outputFileName: string,
	error: any,
}

interface IMapDispatch {
	fetchUploadedChargeLogs: (pageNumber: number, pageSize: number) => Promise<void>;
	setSort: (sort: ISortModel) => void;
	fetchBlobFileUpload: (id: any) => void;
	fetchOutputFile: (id: any) => Promise<any>;
	clearFilters: () => void;
	resetSort: () => void;
	setFilter: (name: string, value: string | boolean | any[] | number) => void;
	applyFilters: () => void;
}

interface IEventLogsProps extends RouteComponentProps, IMapState, IMapDispatch { }

interface IEventLogsState {
	sorted: any[] | ISort[];
	isFieldDisabled: boolean;
	isFetchinProgress: boolean;
	page: number;
	pageSize: number;
	data: any[],
	file: any,
	timeofrequest: number,
	showDialog: boolean,
	message: string,
	isError: boolean,
	filterKey: string,
	filterValue: string,
	shouldSubmitOnLoad: boolean,
	startDate: boolean,
	docNumber: boolean,
}

export class _ChargeExportLogs extends Component<IEventLogsProps, IEventLogsState> {
	public state = {
		sorted: [],
		isFieldDisabled: false,
		isFetchinProgress: false,
		page: 0,
		pageSize: 10,
		timeofrequest: 0,
		file: '',
		showDialog: false,
		shouldSubmitOnLoad: false,
		data: [],
		message: '',
		isError: true,
		filterKey: '',
		filterValue: '',
		startDate: false,
		docNumber: false
	};
	public componentDidUpdate(props: any, state: any) {
		if (this.props.bulkUploadLogsExport !== props.bulkUploadLogsExport && this.props.bulkUploadLogsExport) {
			this.setState({ isFetchinProgress: false });
		}
		if (this.props.error !== props.error && this.props.error) {
			this.setState({
				isFetchinProgress: false,
				showDialog: true,
				isError: true,
				message: this.props.error
			});
		}
	}
	public componentDidMount() {
		this.props.clearFilters();
		this.setState({
			shouldSubmitOnLoad: true,
			pageSize: 10
		}, () => {
			this.fetchEventsList({ page: 0, pageSize: this.state.pageSize });
		});
	}
	public componentWillUnmount() {
		this.props.clearFilters();
		this.props.resetSort();
	}
	public render() {
		return (
			<React.Fragment>
				<Page>
					<div className={'padding-top-xLarge'}>
						<Filters
							tableNameKey="FileUploadFiltersFilters"
							fetchFunction={() => {
								this.targetFetch();
							}}
							resetErrors={() => {
								this.applyEmptyFilters();
								this.setState({ startDate: false, docNumber: false });
							}}
							disableSubmit={this.state.startDate || this.state.docNumber}
							filters={[
								<FiltersInput
									name="fileName"
									label="File Name"
									key="fileName"
									readonly={this.state.isFieldDisabled}
								/>,
								<FiltersSelect
									key="Status"
									name="Status"
									label="Status"
									options={[
										{ optionText: 'Awaiting AntiVirus Scan', label: 'Awaiting AntiVirus Scan', value: 'AwaitingAntiVirusScan' },
										{ optionText: 'Virus Detected', label: 'Virus Detected', value: 'VirusDetected' },
										{ optionText: 'Scanned', label: 'Scanned', value: 'ScannedSuccessfully' },
										{ optionText: 'Scan Bypassed', label: 'Scan Bypassed', value: 'ScanBypassed' },
										{ optionText: 'Scan Error', label: 'Scan Error', value: 'ScanError' },
										{ optionText: 'Partially Processed', label: 'Partially Processed', value: 'PartiallyProcessed' },
										{ optionText: 'Fully Processed', label: 'Fully Processed', value: 'FullyProcessed' },
										{ optionText: 'Rejected', label: 'Rejected', value: 'Rejected' },
									]}
								/>,
								<FiltersInput
									name="uploadedBy"
									label="Uploaded By"
									key="uploadedBy"
									readonly={this.state.isFieldDisabled}
								/>,
								<FiltersDateInput
									name="startDate"
									label="Uploaded time from"
									key="startDate"
									relatedField="endDate"
									type="dateFromTo"
									setValidity={(val: any) => this.setState({ startDate: val })}
									isInvalid={this.state.startDate}
									withTime={false}
								/>,
								<FiltersDateInput
									name="endDate"
									label="Uploaded time to"
									key="dateto"
									type="dateFromTo"
									minValue="startDate"
									setValidity={(val: any) => this.setState({ startDate: val })}
									isInvalid={this.state.startDate}
									withTime={false}
								/>
							]}
						/>
						<InPageDialog
							showDialog={this.state.showDialog}
							type={this.state.isError ? 'error' : 'success'}
							message={this.state.message}
							closeMethod={() => this.setState({ showDialog: false, isError: true })} />
						<ExceptionManagement
							file={this.props.blob}
							cols={colsUploadCharge}
							calculateAging={false}
							fetchData={this.fetchEventsList}
							data={this.props.bulkUploadLogsExport.data}
							sendReprocess={this.fetchEventsList}
							toggleReprocess={this.fetchEventsList}
							tableName={'exception-management-file-upload'}
							pageCount={Math.ceil(this.props.bulkUploadLogsExport.totalCount / this.state.pageSize)}
							linkAction={(id: any) => this.props.fetchBlobFileUpload(id)}
							handleDownload={this.handleDownloadOutputFile}
						/>
					</div>
				</Page>
			</React.Fragment>
		);
	}

	private handleDownloadOutputFile = async (requestId: string) => {
		if (requestId) {
			await this.props.fetchOutputFile(requestId).
				then((data: any) => {
					if (data.outputBlob && data.outputFileName) {
						this.createOutputFile(this.props.outputBlob, this.props.outputFileName);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
	};

	private createOutputFile = (response: any, fileName: string) => {
		const filename = `${fileName}.xlsx`;
		const url = window.URL.createObjectURL(new Blob([response]));
		const linkAnchor = document.createElement('a');
		linkAnchor.href = url;
		linkAnchor.setAttribute('download', filename);
		document.body.appendChild(linkAnchor);
		linkAnchor.click();
		linkAnchor.remove();
	};

	private applyEmptyFilters = () => {
		this.props.applyFilters();
	};
	private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
		this.props.setFilter('Category', 'ESSO');
		const tempPageSize: any = localStorage.getItem('pageSize-exception-management-file-upload') ?
			localStorage.getItem('pageSize-exception-management-file-upload') : pageSize;
		this.setState({
			isFetchinProgress: true,
			pageSize: tempPageSize
		});
		this.props.fetchUploadedChargeLogs(page, tempPageSize);
	};
	private fetchEventsList = (tableData: any) => {
		const samePageRequest = (tableData.page + 1 !== this.state.page || tableData.pageSize !== this.state.pageSize) || (new Date().getTime() - this.state.timeofrequest) > 500;
		if (samePageRequest && this.state.shouldSubmitOnLoad && !this.state.isFetchinProgress) {
			this.setState({
				showDialog: false,
				page: tableData.page + 1,
				pageSize: tableData.pageSize,
				timeofrequest: new Date().getTime(),
				isFetchinProgress: true
			}, () => {
				if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && tableData.sorted[0]!.id === 'errorLogURl') {
					this.setState({ isFetchinProgress: false });
					return;
				}
				if (tableData && tableData.sorted) {
					this.setState({ sorted: tableData.sorted });
					setSortForTable(tableData.sorted, this.props.setSort);
				} else if (this.state.sorted && this.state.sorted.length) {
					setSortForTable(this.state.sorted, this.props.setSort);
				}
				this.targetFetch(this.state.page, this.state.pageSize);
			});
		}
	};
}

const mapStateToProps = (state: IStore): IMapState => ({
	bulkUploadLogsExport: state.ets.bulkUploadLogs,
	nickname: state.nickname.userNickName,
	blob: state.historyLog.blob,
	outputBlob: state.historyLog.outputBlob,
	outputFileName: state.historyLog.outputFileName,
	error: state.exceptions.errors,
});

const mapDispatch = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatch => ({
	fetchUploadedChargeLogs: (pageNumber: number, pageSize: number) => dispatch(fetchUploadedChargeLogs(pageNumber, pageSize)),
	setSort: (sort: ISortModel) => dispatch(setSort(sort)),
	fetchBlobFileUpload: (id: any) => dispatch(fetchBlobFileUpload(id)),
	fetchOutputFile: (id: any) => dispatch(fetchOutputFile(id)),
	clearFilters: () => dispatch(clearFilters()),
	resetSort: () => dispatch(resetSort()),
	setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
	applyFilters: () => dispatch(applyFiltersAction())
});

export const __ChargeExportLogs = connect<IMapState, IMapDispatch, {}, IStore>(mapStateToProps, mapDispatch)(_ChargeExportLogs);
export const ChargeExportLogs = withRouter(__ChargeExportLogs);